// extracted by css-extract-rspack-plugin
export default {"transitionColor":"transitions-module__transitionColor___KxxLs","transitionThemeChange":"transitions-module__transitionThemeChange___QjQnf"};